<template>
  <div>
    <b-toast
      id="save-indicator"
      solid
      ref="saveIndicator"
      :no-close-button="true"
      :no-auto-hide="true"
      :no-fade="true"
      toaster="b-toaster-top-center"
      :visible="isSaveIndicatorVisible"
      data-cy="toast-save-success"
    >
      <div id="loading-icon-wrapper" v-show="indicatorsVisible.saving">
        <img src="@/assets/icons/save-loading.svg" />
      </div>
      <div id="saved-icon-wrapper" v-show="indicatorsVisible.saved">
        <img src="@/assets/icons/save-tick.png" />
      </div>
      <div id="save-indicator-text">
        {{ indicatorsVisible.saving ? "Saving..." : "Saved" }}
      </div>
    </b-toast>
    <b-toast
      id="save-error-indicator"
      solid
      :no-close-button="true"
      :no-auto-hide="true"
      :no-fade="true"
      toaster="b-toaster-top-center"
      v-model="indicatorsVisible.error"
      data-ct="toast-save-error"
    >
      <div id="error-icon-wrapper">
        <img src="@/assets/icons/save-error.svg" />
      </div>
      <div id="save-indicator-text-error">
        Error! Something went wrong
      </div>
      <div id="save-indicator-close-icon">
        <img
          src="@/assets/icons/close_sidebar.svg"
          @click="closeErrorIndicator"
        />
      </div>
    </b-toast>
  </div>
</template>
<script>
export default {
  data() {
    return {
      indicatorsVisible: {
        error: false,
        saving: false,
        saved: false
      }
    };
  },
  computed: {
    isSaveIndicatorVisible() {
      return this.indicatorsVisible.saving || this.indicatorsVisible.saved;
    }
  },
  methods: {
    showSaveIndicator() {
      this.indicatorsVisible.error = false;
      this.indicatorsVisible.saved = false;
      this.indicatorsVisible.saving = true;
    },
    showSaveIndicatorSaved() {
      this.indicatorsVisible.error = false;
      this.indicatorsVisible.saving = false;
      this.indicatorsVisible.saved = true;
      window.setTimeout(() => {
        this.indicatorsVisible.saved = false;
      }, 1500);
    },
    showSaveIndicatorError() {
      this.indicatorsVisible.saving = false;
      this.indicatorsVisible.saved = false;
      this.indicatorsVisible.error = true;
    },
    closeErrorIndicator() {
      this.indicatorsVisible.error = false;
    },
    clearSaveIndicators() {
      this.indicatorsVisible.saving = false;
      this.indicatorsVisible.saved = false;
      this.indicatorsVisible.error = false;
    }
  }
};
</script>
<style lang="scss">
$image-dimension: 25px;
$pink: #f35a63;
$dark-blue: #0a374b;

#save-indicator,
#save-error-indicator {
  border-radius: 999px;
  margin: auto;
  box-shadow: none;
  border: none;
  width: fit-content;
  div.toast-body {
    padding: 10px 5px;
    font-size: 16px;
    display: flex;
  }
}
#save-indicator:focus,
#save-error-indicator:focus {
  border: none;
  outline: none;
}

#save-indicator {
  width: 113px;
  div.toast-body {
    background: $dark-blue;
    border-radius: 999px;
    color: white;
    display: flex;
  }
  #loading-icon-wrapper {
    // flex: 1;
    > img {
      height: $image-dimension;
      width: $image-dimension;
      animation: spin 1s linear infinite;
    }
  }
  #saved-icon-wrapper {
    // flex: 1;
    > img {
      height: $image-dimension;
      width: $image-dimension;
      animation: growIn 1s;
    }
  }
  #save-indicator-text {
    flex: 2;
    text-align: center;
  }
}
#save-error-indicator {
  width: 300px;
  display: flex;
  border-radius: 999px;
  background: #f35a63;
  display: flex;
  > div.toast-body {
    flex: 1;
  }
  #save-indicator-text-error {
    color: white;
  }
  #error-icon-wrapper {
    background: #f35a63;
    border-bottom-left-radius: 999px;
    border-top-left-radius: 999px;
    color: white;
    flex: 1;
    > img {
      height: $image-dimension;
      width: $image-dimension;
    }
  }
  #save-indicator-text {
    color: white;
    background: #f35a63;
    flex: 8;
    text-align: center;
  }
  #save-indicator-close-icon {
    background: #f35a63;
    color: white;
    width: $image-dimension;
    height: $image-dimension;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    > img {
      cursor: pointer;
      flex: 1;
      height: $image-dimension;
      width: $image-dimension;
    }
    border-bottom-right-radius: 999px;
    border-top-right-radius: 999px;
  }
}
.spinner-wrapper {
  margin-left: auto;
  padding-right: 1.5rem;
  display: flex;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes growIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
</style>
